import React, { useEffect, useState } from "react";
import {getImporterContainerProducts} from "../../api/container";
import {useSelector} from "react-redux";
import { useTranslation } from "react-i18next";
import ListSection from "../../components/layout/list-section";
import NumberFormat from "react-number-format";
import ProductCell from "../../components/common/table/product-cell";
import TableDetail from "../../components/common/list/table-detail";
import CardDetail from "../../components/common/list/card-detail";
import {InfoButton} from "../../components/layout/page-header";
import LoadDetail from "./panel/container/edit/load-configuration/load-detail";
import {InformationCircleIcon} from "@heroicons/react/outline";


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const ContainerProducts = ({isSeaType, containerDetail, shipping}) => {
    const { loggedCompany } = useSelector((state) => state.user);
    const { company } = useSelector((state) => state.userCompany);

    const { t } = useTranslation();

    const columns = [
        t("app.container.product"),
        t("app.container.quantity"),
        t("app.container.net_weight"),
        t("app.container.gross_weight"),
        t("app.container.volume"),
        t("app.container.price"),
        t("app.container.total_price"),
        "",
    ];

    const [isLoading, setLoading] = useState(true);
    const [isOpenDetail, setOpenDetail] = useState(false);

    const [detail, setDetail] = useState({
        products: [],
        stocks: [],
        total_rows: 0,
    });

    const [query, setQuery] = useState("");

    const totalVolume = isSeaType ? containerDetail.container_type.volume : 0

    const [containerLoadDetails, setContainerLoadDetails] = useState({
        total_volume: 0,
        total_gross_weight: 0,
        total_net_weight: 0,
        percentage: 0,
        total_price: 0,
    });



    const groupContainerLoad = (detail, containerDetail) => {
        let result = {
            total_volume: 0,
            total_gross_weight: 0,
            total_net_weight: 0,
            total_price: 0,
        };

        // eslint-disable-next-line
        detail.products.map(data => {
            result['total_volume'] = result['total_volume'] + (data.base_volume * data.quantity);
            result['total_gross_weight'] = result['total_gross_weight'] + (data.base_gross_weight * data.quantity);
            result['total_net_weight'] = result['total_net_weight'] + (data.base_net_weight * data.quantity);
            result['total_price'] = result['total_price'] + (data.base_price * data.quantity);
        });

        result['percentage'] = result.total_volume > 0 && totalVolume > 0 ? (result.total_volume / totalVolume) * 100 : 0;
        return result;
    };


    useEffect( () => {
        if(detail.products){
            setContainerLoadDetails(groupContainerLoad(detail, containerDetail));
        }
        // eslint-disable-next-line
    }, [detail.products]);






    useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    function fetchContainerProducts() {
      if (loggedCompany) {
        setLoading(true);
          getImporterContainerProducts({ shipping_id: shipping.id, container_id: containerDetail.id, params: { query: query }, signal })
            .then((response) => {
              setDetail(response);
              setLoading(false);
            })
            .catch((e) => {
              setDetail({ products: [], total_rows: 0, stocks: []});
              setLoading(false);
            });
      }
    }

    fetchContainerProducts();
    return () => {
      controller.abort();
    };
  }, [query, loggedCompany, containerDetail, shipping]);

  return (

     <>
         <ListSection
             title={t("app.container.products")}
             columns={columns}
             totalRows={detail.total_rows}
             list={detail.products}
             onSearch={setQuery}
             isLoading={isLoading}
             mobileRow={ContainerMobRow}
             desktopRow={ContainerDeskRow}
             hasCheckbox={true}
             isActiveSelectAll={false}
             extras={{
                 stocks: detail.stocks
             }}
         >
             <InfoButton
                 onClick={() => {
                     setOpenDetail(true);
                 }}
                 icon={
                     <InformationCircleIcon
                         className="w-6 h-6"
                         aria-hidden="true"
                     />
                 }
                 text={ t("app.container.container_status")}
             />
         </ListSection>


         <LoadDetail
             isOpen={isOpenDetail}
             isSeaType={false}
             containerDetail={containerDetail}
             containerLoadDetails={containerLoadDetails}
             currency={company.currency?.currency_symbol ?? ''}
             setIsOpen={(r) => {
                 setOpenDetail(r);
             }}
         />
     </>

  );
};

const ContainerMobRow = ({ element, extras}) => {
    const { t } = useTranslation();
    const { company } = useSelector((state) => state.userCompany);
  return (
      <li key={element.id} className={'flex items-center gap-4 p-4'}>
          <div className="flex-grow">

              <div className="flex flex-col">

                  <CardDetail title={t("app.container.quantity")}>
                      <NumberFormat
                          value={(element.quantity - element.available_quantity)}
                          displayType={"text"}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                      />
                      /
                      <NumberFormat
                          value={element.quantity}
                          displayType={"text"}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                      />
                  </CardDetail>


                  <CardDetail title={t("app.container.net_weight")}>
                      <div className="flex justify-between gap-1 items-center">
                          <NumberFormat
                              value={element.base_net_weight * element.quantity}
                              displayType={"text"}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              decimalScale={2}
                              suffix={' Kg'}
                          />
                          (
                          <div className="text-xs text-gray-500">
                              <NumberFormat
                                  value={element.base_net_weight}
                                  displayType={"text"}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  decimalScale={5}
                                  suffix={' Kg'}
                              />
                          </div>
                          )
                      </div>
                  </CardDetail>

                  <CardDetail title={t("app.container.gross_weight")}>
                      <div className="flex justify-between gap-1 items-center">
                          <NumberFormat
                              value={element.base_gross_weight * element.quantity}
                              displayType={"text"}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              decimalScale={2}
                              suffix={' Kg'}
                          /> (
                          <div className="text-xs text-gray-500">
                              <NumberFormat
                                  value={element.base_gross_weight}
                                  displayType={"text"}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  decimalScale={5}
                                  suffix={' Kg'}
                              />
                          </div>
                          )
                      </div>
                  </CardDetail>
                  <CardDetail title={t("app.container.volume")}>
                      <div className="flex justify-between gap-1 items-center">
                          <NumberFormat
                              value={element.base_volume * element.quantity}
                              displayType={"text"}
                              thousandSeparator={"."}
                              decimalScale={2}
                              decimalSeparator={","}
                              suffix={' m³'}
                          />
                          (
                          <div className="text-xs text-gray-500">
                              <NumberFormat
                                  value={element.base_volume}
                                  displayType={"text"}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  decimalScale={5}
                                  suffix={' m³'}
                              />
                          </div>
                          )

                      </div>
                  </CardDetail>

                  <CardDetail title={t("app.container.price")}>
                      <div className="flex justify-between gap-1 items-center">
                      <NumberFormat
                                  value={element?.base_price ?? 0}
                                  displayType={"text"}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  suffix={" " + (company.currency?.currency_symbol ?? '')}
                              />

                      </div>
                  </CardDetail>


                  <CardDetail title={t("app.container.total_price")}>
                      <div className="flex justify-between gap-1 items-center">
                          <NumberFormat
                              value={element?.base_price * element.quantity ?? 0}
                              displayType={"text"}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              decimalScale={2}
                              suffix={" " + (company.currency?.currency_symbol ?? '')}
                          />

                      </div>
                  </CardDetail>
              </div>
          </div>
      </li>
  );
};

const ContainerDeskRow = ({ element, extras }) => {
    const percentage =  ((element.quantity - element.available_quantity) * (100 / element.quantity));
    const { company } = useSelector((state) => state.userCompany);


  return (
      <tr key={element.id} >
          <TableDetail extraClass={"whitespace-pre-line"}>
              <ProductCell isActiveImage={true} product={element.product}/>
          </TableDetail>

          <TableDetail>
              <div className="flex before:flex-1 justify-between mb-1">
                  <div className="text-xs text-gray-900">
                      <NumberFormat
                          value={(element.quantity - element.available_quantity)}
                          displayType={"text"}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                      />
                       /
                      <NumberFormat
                          value={element.quantity}
                          displayType={"text"}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                      />
                  </div>
              </div>
              <div className="w-full bg-gray-200 rounded">
                  <div className={classNames(
                      percentage >= 50 ? 'shim-green' : '',
                      percentage < 50  ? 'shim-red' : '',
                      "text-xs font-medium rounded text-white text-center p-2 leading-none"
                  )} style={{width: percentage+'%'}}>
                  </div>
              </div>


         </TableDetail>





        <TableDetail>
          <div className="text-sm text-gray-900">
              <NumberFormat
                  value={element.base_net_weight * element.quantity}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  decimalScale={2}
                  suffix={' Kg'}
              />
          </div>
          <div className="text-xs text-gray-500">
              <NumberFormat
                  value={element.base_net_weight}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  decimalScale={5}
                  suffix={' Kg'}
              />
          </div>
        </TableDetail>

        <TableDetail>
          <div className="text-sm text-gray-900">
              <NumberFormat
                  value={element.base_gross_weight * element.quantity}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  decimalScale={2}
                  suffix={' Kg'}
              />
          </div>
          <div className="text-xs text-gray-500">
              <NumberFormat
                  value={element.base_gross_weight}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  decimalScale={5}
                  suffix={' Kg'}
              />
          </div>
        </TableDetail>


        <TableDetail>
            <div className="text-sm text-gray-900">
                <NumberFormat
                    value={element.base_volume * element.quantity}
                    displayType={"text"}
                    thousandSeparator={"."}
                    decimalScale={2}
                    decimalSeparator={","}
                    suffix={' m³'}
                />
            </div>
            <div className="text-xs text-gray-500">
                <NumberFormat
                    value={element.base_volume}
                    displayType={"text"}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    decimalScale={5}
                    suffix={' m³'}
                />
            </div>
        </TableDetail>
        <TableDetail>
            <div className="text-sm text-gray-900">
            <NumberFormat
                    value={element?.base_price ?? 0}
                    displayType={"text"}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    suffix={" " + (company.currency?.currency_symbol ?? '')}
                />
            </div>
        </TableDetail>


        <TableDetail>
            <div className="text-sm text-gray-900">
                <NumberFormat
                    value={element?.base_price * element.quantity ?? 0}
                    displayType={"text"}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    decimalScale={2}
                    suffix={" " + (company.currency?.currency_symbol ?? '')}
                />
            </div>
        </TableDetail>


          <TableDetail>
        </TableDetail>
      </tr>
  );
};




export default ContainerProducts;
